import type { ScanServiceStatus } from '@witmetrics/utils';
import { SCAN_SERVICE_STATUS } from '@witmetrics/utils/constants';

const { IN_PROGRESS, COMPLETE, FAILED, CANCELED } = SCAN_SERVICE_STATUS;

export const classes = {
  label:
    'inline-flex items-center rounded-full px-[11px] py-1 text-[11.5px] font-semibold leading-none',
};

export function getStatusColors(status: ScanServiceStatus) {
  const colors = {
    [IN_PROGRESS]: 'text-[#dd7c0a] bg-[#f59e0b]/[0.18]',
    [COMPLETE]: 'text-[#15a04a] bg-[#16a34a]/[0.15]',
    [FAILED]: 'text-[#dc2626] bg-[#ef4444]/[0.15]',
    [CANCELED]: 'text-[#6b7688] bg-[#64748b]/[0.17]',
  };
  return colors[status];
}
